import { setCarouselWidth, countSlides, progressSlides } from './index';

$(function() {
    let $heroSlider = $('.js-hero-slider'),
        $heroSlide = $('.js-hero-slide'),
        $recentStreamInsightsSlider = $('.js-recent-stream-insights-slider'),
        $streamInActionSlider = $('.js-stream-in-action-slider'),
        $whoWeAreSlider = $('.js-who-we-are-slider'),
        $whoWeArePostsSlider = $('.js-who-we-are-posts-slider'),
        $servicesSlider = $('.js-services-slider'),
        $insightsImgSlider = $('.js-insights-images-slider'),
        $insightsPostSlider = $('.js-insights-posts-slider'),
        $lastNewsSlider = $('.js-last-news-slider'),
        $discoverSlider = $('.js-discover-slider'),
        $featuredCaseStudiesSlider = $('.js-featured-case-studies-slider'),
        $featuredLocationsSlider = $('.js-featured-locations-slider'),
        $awardsSlider = $('.js-awards-slider'),
        $singlePostSlider = $('.js-content-single-post .gallery'),
        $singleSolutionsSlider = $('.js-featured-images-slider'),
        $videoCarousel = $('.js-video-carousel'),
        $leadershipCarousel = $('.js-leadership-carousel'),
        $whoWeAreIntroSlider = $('.js-who-we-are-intro-slider'),
        percentTime,
        tick,
        time = .1,
        progressBarIndex = 0;


    $heroSlider.slick({
        dots: true,
        infinite: true,
        fade: true,
        autoplay: true,
        arrows: false,
        draggable: false,
        pauseOnFocus: false,
        autoplaySpeed: 6500,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendDots: $('.js-hero-slider-nav'),
        customPaging : function(slider, i) {
            let title = $(slider.$slides[i])
                .data('title');
            return `<a>
                <span class="hero-slider__progress">
                <span class="inProgress inProgress${i}"></span>
                </span>
                ${title}
                </a>`;
        },
    });

    $heroSlide.addClass('transition-active');

    function startProgressbar() {
        resetProgressbar();
        percentTime = 0;
        tick = setInterval(interval, 10);
    }

    function interval() {
        if (($('.js-hero-slider .slick-track div[data-slick-index="' + progressBarIndex + '"]').attr('aria-hidden')) === "true") {
            progressBarIndex = $('.js-hero-slider .slick-track div[aria-hidden="false"]').data('slickIndex');
            startProgressbar();
        } else {
            percentTime += 1 / (time + 6.5);
            $('.inProgress' + progressBarIndex).css({
                width: percentTime + '%'
            });
            if (percentTime >= 100) {
                $('.js-hero-slider').slick('slickNext');
                progressBarIndex++;
                if (progressBarIndex > 2) {
                    progressBarIndex = 0;
                }
                startProgressbar();
            }
        }
    }

    function resetProgressbar() {
        $('.inProgress').css({
            width: 0 + '%'
        });
        clearInterval(tick);
    }
    startProgressbar();

    $recentStreamInsightsSlider.on('init afterChange', function() {
        let $currentSlide = $('.js-recent-stream-insights-slider .slick-current'),
            $preview = $currentSlide.attr('data-preview'),
            $previewBlock = $('.js-preview-slide');
        $previewBlock.fadeTo(200, .3, function()
        {
            $previewBlock.css('background-image', `url(${$preview})`);
        }).fadeTo(200, 1);
    });

    $recentStreamInsightsSlider.slick({
        dots: true,
        infinite: true,
        autoplay: false,
        arrows: false,
        draggable: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 813,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $streamInActionSlider.slick({
        dots: true,
        infinite: true,
        fade: true,
        autoplay: false,
        arrows: false,
        draggable: false,
        slidesToShow: 1,
        slidesToScroll: 1
    });

    $whoWeAreSlider.slick({
        dots: false,
        infinite: true,
        autoplay: false,
        arrows: true,
        draggable: true,
        variableWidth: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $('.js-who-we-are-slider-nav > .slick-prev'),
        nextArrow: $('.js-who-we-are-slider-nav > .slick-next'),
        asNavFor: '.js-who-we-are-posts-slider'
    });

    $whoWeArePostsSlider.slick({
        dots: false,
        infinite: true,
        fade: true,
        autoplay: false,
        arrows: false,
        draggable: false,
        slidesToShow: 1,
        slidesToScroll: 1
    });

    $servicesSlider.slick({
        dots: false,
        infinite: true,
        autoplay: false,
        arrows: true,
        draggable: false,
        variableWidth: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: $('.js-services-slider-nav > .slick-prev'),
        nextArrow: $('.js-services-slider-nav > .slick-next')
    });

    setCarouselWidth('js-services-slider');

    $insightsImgSlider.on('init', function(event, slick, currentSlide) {
        let
            cur = $(slick.$slides[slick.currentSlide]),
            next = cur.next(),
            prev = cur.prev();
        prev.addClass('slick-sprev');
        next.addClass('slick-snext');
        cur.removeClass('slick-snext').removeClass('slick-sprev');
        slick.$prev = prev;
        slick.$next = next;
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        let
            cur = $(slick.$slides[nextSlide]);
        slick.$prev.removeClass('slick-sprev');
        slick.$next.removeClass('slick-snext');
        let next = cur.next(),
            prev = cur.prev();
        prev.prev();
        prev.next();
        prev.addClass('slick-sprev');
        next.addClass('slick-snext');
        slick.$prev = prev;
        slick.$next = next;
        cur.removeClass('slick-next').removeClass('slick-sprev');
    });

    $insightsImgSlider.slick({
        dots: false,
        infinite: true,
        autoplay: false,
        arrows: true,
        draggable: false,
        centerMode: true,
        centerPadding: '0',
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $('.js-insights-images-slider-nav > .slick-prev'),
        nextArrow: $('.js-insights-images-slider-nav > .slick-next'),
        asNavFor: '.js-insights-posts-slider'
    });

    $insightsPostSlider.slick({
        dots: false,
        infinite: true,
        fade: true,
        autoplay: false,
        arrows: false,
        draggable: false,
        slidesToShow: 1,
        slidesToScroll: 1
    });

    progressSlides($lastNewsSlider, $('.js-latest-news-progress'));

    countSlides($lastNewsSlider, $('.js-latest-news-counter'));

    $lastNewsSlider.slick({
        dots: false,
        infinite: true,
        autoplay: false,
        arrows: true,
        draggable: false,
        variableWidth: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: $('.js-last-news-slider-nav > .slick-prev'),
        nextArrow: $('.js-last-news-slider-nav > .slick-next'),
        responsive: [
            {
                breakpoint: 641,
                settings: {
                    centerMode: true
                }
            }
        ]
    });

    setCarouselWidth('js-last-news-slider');

    $discoverSlider.slick({
        dots: false,
        infinite: true,
        autoplay: false,
        arrows: true,
        draggable: false,
        variableWidth: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: $('.js-discover-slider-nav > .slick-prev'),
        nextArrow: $('.js-discover-slider-nav > .slick-next')
    });

    setCarouselWidth('js-discover-slider');

    $featuredCaseStudiesSlider.flickity({
        cellAlign: 'center',
        wrapAround: true,
        contain: true,
        pageDots: false,
        prevNextButtons: false
    });

    $featuredLocationsSlider.slick({
        dots: false,
        infinite: true,
        autoplay: false,
        arrows: false,
        draggable: true,
        centerMode: true,
        centerPadding: '200px',
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    centerPadding: '100px'
                }
            },
            {
                breakpoint: 813,
                settings: {
                    centerPadding: '60px'
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerPadding: '30px'
                }
            },
            {
                breakpoint: 641,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '40px'
                }
            },
            {
                breakpoint: 481,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '55px'
                }
            },
            {
                breakpoint: 321,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '30px'
                }
            }
        ]
    });

    $awardsSlider.slick({
        dots: false,
        infinite: true,
        autoplay: false,
        arrows: false,
        draggable: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 993,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 641,
                settings: "unslick"
            }
        ]
    });

    $singlePostSlider.on('init', function(event, slick) {
        let $sliders = slick.$slider;
        if (slick.slideCount < 2) {
            return null;
        } else {
            $sliders.each(function(index, slider) {
                slider.classList.add('js-single-post-gallery-cursor');
            });
        }
    });

    $singlePostSlider.slick({
        dots: false,
        infinite: true,
        autoplay: false,
        arrows: false,
        draggable: true,
        centerMode: true,
        variableWidth: true,
        centerPadding: '40px',
        slidesToShow: 1,
        slidesToScroll: 1
    });

    $singleSolutionsSlider.slick({
        dots: false,
        infinite: true,
        autoplay: true,
        arrows: true,
        draggable: true,
        pauseOnHover: false,
        autoplaySpeed: 7000,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $('.js-featured-images-slider-nav > .slick-prev'),
        nextArrow: $('.js-featured-images-slider-nav > .slick-next')
    });

    $videoCarousel.slick({
        dots: false,
        infinite: true,
        autoplay: false,
        arrows: false,
        draggable: true,
        centerMode: true,
        variableWidth: true,
        centerPadding: '40px',
        slidesToShow: 1,
        slidesToScroll: 1,
    });

    progressSlides($leadershipCarousel, $('.js-leadership-carousel-progress'));

    countSlides($leadershipCarousel, $('.js-leadership-carousel-counter'));

    $leadershipCarousel.slick({
        dots: false,
        infinite: true,
        autoplay: false,
        arrows: true,
        draggable: false,
        variableWidth: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: $('.js-leadership-carousel-nav > .slick-prev'),
        nextArrow: $('.js-leadership-carousel-nav > .slick-next'),
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 481,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    });

    setCarouselWidth('js-leadership-carousel');

    $whoWeAreIntroSlider.slick({
        dots: false,
        infinite: true,
        autoplay: true,
        arrows: false,
        draggable: true,
        centerMode: true,
        variableWidth: true,
        centerPadding: '40px',
        slidesToShow: 1,
        slidesToScroll: 1
    });
});